module.exports = __webpack_public_path__ + "img/default-exhibit.3b799844.png";